// Collections v2 supports. Crop-required ones work because a crop image hands
// off to the legacy cropperjs dialog (see _browseV2 in media_manager.js). Still
// excluded: the CartImage collections (product_image, campaign_image), since
// v2's library endpoint omits CartImage. Listed explicitly so adding a
// collection is a deliberate opt-in (see MediaFilters for the full set).
const V2_SUPPORTED_ACCEPTS = new Set([
   'wiki_media',
   'wiki_summary_image',
   'profile_image',
   'guide_main_image',
   'guide_step_image',
   // Object/video/embed/document collections need no crop support at all;
   // guide_step_object covers the guide intro video target too.
   'guide_step_object',
   'guide_step_video',
   'guide_step_embed',
   'guide_document',
]);

/** Whether Media Manager v2 can handle this filter collection (flag aside). */
export function acceptsSupportsMediaManagerV2(accepts: string): boolean {
   return V2_SUPPORTED_ACCEPTS.has(accepts);
}
